export const environment = {
	production: true,
	url: `${window.location.protocol}//${window.location.hostname}/api/`,
	apiUrl: `${window.location.protocol}//${window.location.hostname}/api`,
	auth: {
		url: `${window.location.protocol}//${window.location.hostname}/auth`,
		realm: "harpia",
		clientId: "frontend-identity-service",
		logoutUri: `${window.location.protocol}//${window.location.hostname}/sign-out`,
	}
};